
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const token = localStorage.getItem("accessToken");
export const baseQuery = fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL,
    headers: {Authorization: `Bearer ${token}`},
});
